export const categories = [
  {
    slug: "zuixin-dizhi",
    name: "最新地址",
    description: "爱情岛论坛最新官方入口地址汇总，提供最新可用线路",
    icon: "ri-link",
  },
  {
    slug: "xianlu-gengxin",
    name: "线路更新",
    description: "实时追踪爱情岛论坛地址变更，第一时间更新可用线路",
    icon: "ri-refresh-line",
  },
  {
    slug: "shiyong-zhinan",
    name: "使用指南",
    description: "详细的爱情岛论坛访问教程与操作指南",
    icon: "ri-book-open-line",
  },
  {
    slug: "changjian-wenti",
    name: "常见问题",
    description: "关于爱情岛论坛网址访问的常见问题解答",
    icon: "ri-question-answer-line",
  },
  {
    slug: "anquan-fanghu",
    name: "安全防护",
    description: "安全访问爱情岛论坛的防护建议与注意事项",
    icon: "ri-shield-check-line",
  },
];